var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaptain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4,4.3l-1.7-1.7c-0.2-0.2-0.5-0.4-0.9-0.4H5.2c-0.3,0-0.7,0.1-0.9,0.4L2.6,4.3C2.4,4.6,2.2,4.9,2.2,5.2v16.5h16.5 c0.3,0,0.6-0.1,0.9-0.4l1.7-1.7c0.2-0.2,0.4-0.5,0.4-0.9V5.2C21.8,4.9,21.6,4.6,21.4,4.3z M20.2,18.7l-1.6,1.6H3.8V5.3l1.6-1.6 h13.4l1.6,1.6V18.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2,6H9.5C9.3,6,9,6.1,8.9,6.3L7.3,7.9C7.1,8,7,8.3,7,8.5v7c0,0.3,0.1,0.5,0.3,0.7l1.6,1.6C9,17.9,9.3,18,9.5,18h4.7 c0.3,0,0.5-0.1,0.7-0.3l1.8-1.8v-0.2L15,14.2h-0.2l-1.1,1.1c-0.1,0.1-0.2,0.1-0.3,0.1h-2.8c-0.1,0-0.2,0-0.3-0.1l-0.4-0.4 c-0.1-0.1-0.1-0.2-0.1-0.3V9.5c0-0.1,0-0.2,0.1-0.3l0.4-0.4c0.1-0.1,0.2-0.1,0.3-0.1h2.8c0.1,0,0.2,0,0.3,0.1l1.1,1.1H15l1.6-1.6V8 l-1.8-1.8C14.7,6.1,14.5,6,14.2,6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaptain);
export default __webpack_public_path__ + "static/media/captain.813f024e.svg";
export { ForwardRef as ReactComponent };